import { render, staticRenderFns } from "./BuildingDetail.vue?vue&type=template&id=7881e4d7&"
import script from "./BuildingDetail.vue?vue&type=script&lang=js&"
export * from "./BuildingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports